exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".destinations-component{position:relative;height:calc(100vh - 49px)}.destinations-component .bottom{position:absolute;bottom:10px;width:100%;padding:0 8px}.destinations-component .bottom .categories{display:flex;align-items:center;justify-content:space-around}.destinations-component .bottom .item{padding:5px 15px;margin:5px 0;border-radius:15px;cursor:pointer}.destinations-component .bottom .item.active{background:#35b76f;color:#fff;border:none}.destinations-component .center{padding:50px 8px 0;height:calc(100vh - 150px);overflow:scroll;-webkit-overflow-scrolling:touch}.destinations-component .center .country{display:block;float:left;width:33.3333%;padding:8px}.destinations-component .center .country .name{color:#0a0a0a;padding:5px;text-align:center}.destinations-component .center .country .cover img{border-radius:5px;width:calc((100vw - 16px) / 3 - 16px);height:calc((100vw - 16px) / 3 - 16px);background:#f5f5f5}@media only screen and (min-width:800px){.destinations-component .center .country .cover img{height:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/develop/Destinations.scss
// module id = 610
// module chunks = 0